<!-- Wrapper -->
<div fxLayout="column">
    <!-- Content -->
    <div fxLayout="column">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>
</div>